// Function to get UTM parameters from URL and store them in localStorage if different from existing
function getUTMParameters() {
    const params = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];
    const currentParams = {};
    let isDifferent = false;

    // Retrieve current URL parameters
    params.forEach(param => {
        const value = new URLSearchParams(window.location.search).get(param);
        if (value) currentParams[param] = value;
    });

    // Retrieve stored UTM parameters from localStorage
    const storedParams = JSON.parse(localStorage.getItem('utmParams')) || {};

    // Check if the current UTM parameters are different from the stored ones
    params.forEach(param => {
        if (currentParams[param] && currentParams[param] !== storedParams[param]) {
            isDifferent = true;
            storedParams[param] = currentParams[param];  // Update storedParams with currentParam
        }
    });

    // Update localStorage only if parameters are different
    if (isDifferent) {
        localStorage.setItem('utmParams', JSON.stringify(storedParams));
    }

    // Update flo-analytics with UTM parameters if missing
    // try {
    //     let floAnalytics = JSON.parse(localStorage.getItem('flo-analytics')) || {};
    //     floAnalytics.utmParams = floAnalytics.utmParams || [];
    
    //     params.forEach(param => {
    //         if (currentParams[param]) {
    //             const existingParam = floAnalytics.utmParams.find(p => p.name === param);
    //             if (!existingParam) {
    //                 floAnalytics.utmParams.push({ name: param, value: currentParams[param] });
    //             } else if (!existingParam.value) {
    //                 existingParam.value = currentParams[param];
    //             }
    //         }
    //     });
    
    //     localStorage.setItem('flo-analytics', JSON.stringify(floAnalytics));
    // } catch (error) {
    //     console.error('An error occurred:', error);
    // }
}

// Function to append UTM parameters to all links on the page
function appendUTMParameters() {
    const utmParams = JSON.parse(localStorage.getItem('utmParams'));
    if (utmParams) {
        document.querySelectorAll('a').forEach(link => {
            try {
                const url = new URL(link.href);
                Object.keys(utmParams).forEach(key => {
                    url.searchParams.set(key, utmParams[key]);
                });
                link.href = url.toString();
            } catch (error) {
                console.log(`Invalid URL: ${link.href}`, error);
            }
        });
    }
}

// Immediately get UTM parameters from URL
getUTMParameters();

// Wait until the DOM is fully loaded to append UTM parameters to links
document.addEventListener('DOMContentLoaded', appendUTMParameters);
